export const searchByContainsTerm = (searchTerm, searchOptions) => {
    const lowerTerm = searchTerm.toLocaleLowerCase();
    return searchOptions.filter((option) => option.text.toLocaleLowerCase().includes(lowerTerm));
};
